import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Column } from '@simplywallst/ui-core';

export const FiltersContainer = styled('div')`
  background-color: ${({ theme }) => theme.color.noir};
  padding-top: ${({ theme }) => theme.x3space}rem;
  padding-bottom: ${({ theme }) => theme.x3space}rem;
`;

export const FilterColumn = styled(Column)`
  padding-left: ${({ theme }) => theme.x2space}rem;
  padding-right: ${({ theme }) => theme.x2space}rem;
  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  }
  ${media.mdDown`
    padding-bottom: ${({ theme }) => theme.x2space}rem;
  `};
`;

export const FilterColumnRule = styled('hr')`
  display: none;
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  margin-bottom: 0px;
  ${media.smDown`
    display: block;
  `}
`;

export const FilterLabel = styled('label')`
  display: block;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.paleWhiteRGBA(0.5)};
  margin: 0;
  ${media.smUp`
    padding-bottom: ${({ theme }) => theme.x1spacePx}px;
  `}
`;

export const ControlsContainer = styled(Column)`
  button + button {
    margin-left: ${({ theme }) => theme.x1space}rem;
  }
  padding-top: ${({ theme }) => theme.x2space}rem;
  padding-left: ${({ theme }) => theme.x2space}rem;
  padding-right: ${({ theme }) => theme.x2space}rem;
  ${media.mdDown`
    padding-bottom: ${({ theme }) => theme.x2space}rem;
  `};
`;

export const SnowflakeColumn = styled(Column)`
  ${media.mdDown`
    max-width: 320px;
    margin: auto;
  `}
`;
